module.exports = __webpack_public_path__ + "static/media/spot_banner.08f144d2.svg";